import styled from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import {
  XSMALL_BREAKPOINT,
  XXSMALL_BREAKPOINT,
  SMALL_BREAKPOINT,
  PLATFORM_BREAKPOINT,
} from '../../style'

export const DashboardWrapper = styled.div`
  background: ${colors.dust};
`
export const Container = styled.div<{ isManager?: boolean; newSidebarActive?: boolean }>`
  display: flex;
  ${({ newSidebarActive, isManager }) =>
    !newSidebarActive && `padding-top: ${isManager ? `5.2rem` : `3.2rem`};`} width: 100%;
  margin: 0 0 0 auto;
  background: #f4f5f5;
`
export const Content = styled.div<{
  isSubBrandView?: string | null
  newSidebarActive?: boolean
  isNavCollapsed?: boolean
}>`
  display: flex;
  flex: 1;
  width: 100%;
  margin: 0 auto;
  position: relative;
  min-height: 100vh;
  max-width: ${({ newSidebarActive }) => (newSidebarActive ? `100%` : `${PLATFORM_BREAKPOINT}`)};
  box-sizing: content-box;
  ${({ newSidebarActive }) => newSidebarActive && `padding-left: 13.125rem;`}
  ${({ isNavCollapsed }) => isNavCollapsed && `padding-left: 4.5rem;`}
  
  @media all and (max-width: ${PLATFORM_BREAKPOINT}) {
    box-sizing: border-box;
  }

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    max-width: 100%;
    display: block;
    padding: 0;
  }

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    padding-bottom: 4.375rem;
  }
`

export const Sidebar = styled.div`
  width: 24rem;
  max-height: 100vh;
  position: relative;
  overflow: hidden;

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    display: none;
  }
`
export const SidebarInner = styled.div`
  position: fixed;
  top: 3.25rem;
  bottom: 0;
  width: 24rem;
`
export const OrderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.radagast};
  padding-bottom: 1rem;
  margin-bottom: 2.25rem;
  position: relative;

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
  }
`
export const Tabs = styled.div`
  display: flex;
`
export const Tab = styled.div<{ active?: boolean }>`
  font-weight: 900;
  font-size: 1.25rem;
  line-height: 1.75rem;
  margin-right: 1.5rem;
  color: ${({ active }) => (active ? colors.black1 : colors.dawn)};
  cursor: pointer;

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    font-size: 1rem;
  }
`
export const OrdersLink = styled.a`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: ${colors.adaptBlue};

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    position: absolute;
    right: 0;
    bottom: -1.5rem;
  }
`
export const BrandOrderCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -12px;

  > div {
    width: calc(33% - 24px);
    margin: 12px;

    @media all and (max-width: ${XSMALL_BREAKPOINT}) {
      width: calc(50% - 24px);
      height: auto;
    }

    @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
      width: calc(100% - 24px);
    }
  }
`
export const BrandWalletCards = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -0.875rem;
  margin-bottom: 1.563rem;

  > div {
    width: calc(50% - 1.75rem);
    margin: 0.875rem;
    max-width: 100%;

    @media all and (max-width: ${XSMALL_BREAKPOINT}) {
      width: 30rem;
      height: auto;
    }

    @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
      width: calc(100% - 1.75rem);
    }
  }
`
export const SectonTitle = styled.h4`
  font-weight: 900;
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: ${colors.black1};
  margin-bottom: 1rem;
  margin-top: 2.25rem;

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    margin-bottom: 0.75rem;
  }
`
export const NoWallet = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 5rem;
  padding-bottom: 11rem;

  h4 {
    margin-bottom: 1rem;
    max-width: 21rem;
  }
`
export const NowalletButton = styled.button`
  background: ${colors.adaptBlue};
  border-radius: 6.25rem;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.125rem;
  border: 0;
  width: 12rem;
  height: 3.25rem;
`
export const DashboardContent = styled.div<{ newSidebarActive?: boolean }>`
  display: block;
  width: 100%;

  &.settings {
    max-width: 105rem;
    margin: 0 auto;
  }

  padding: ${({ newSidebarActive }) => (newSidebarActive ? `1.5rem 4rem 0` : `1.5rem 0 0 14.5rem`)};

  ${({ newSidebarActive }) =>
    newSidebarActive
      ? `
        @media all and (max-width: 1920px) {
          padding: 1.5rem 3rem 0;
        }
        @media all and (max-width: 1680px) {
          padding: 1.5rem 2.25rem 0;
        }
        @media all and (max-width: 1440px) {
          padding: 1.5rem 1.5rem 0;
        }

        body.our-enterprise &,
        body.team &,
        body.settings &,
        body.new-order & {
          padding-top: 6.25rem;

          @media all and (max-width: ${SMALL_BREAKPOINT}) {
            padding-top: 4rem;
          }
        }
        body.wallets & {
          padding-top: 6.25rem;
        }
      `
      : `
        @media all and (max-width: ${PLATFORM_BREAKPOINT}) {
          padding: 2.25rem 1.5rem 0 13.75rem;
        }

        @media all and (max-width: ${SMALL_BREAKPOINT}) {
          width: 100%;
          padding: 3.25rem 1.25rem 2.25rem;
        }
    `};
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboard.style.tsx